import React from "react";
import { Provider } from "react-redux";
import { store } from "./app/store";
import Router from "./routes";
import "./fonts.css";
import "./App.css";

function App() {
  return (
    <Provider store={store}>
      <Router />
    </Provider>
  );
}

export default App;
